<template>
    <modal
        class="table-filter-modal modal-filter-product"
        size="medium"
        @close="close"
        v-if="show"
    >
        <div slot="header">
            <h3>
                <i class="material-icons mr-2">filter_list</i>
                <span>{{ $t('Filter Products') }}</span>
            </h3>
        </div>
        <div slot="body">
            <div class="row">
                <div class="col-12">
                    <span class="text-bold mb-2 d-flex">{{ $t('Products') }}</span>
                    <product-multi-select
                        v-model="newSelectedProducts"
                        :selected-products="newSelectedProducts"
                        @input="onSelectProducts"
                    />
                </div>
                <div class="col-12 mt-2" v-if="newSelectedProducts.length > 0">
                    <div class="card mb-2">
                        <div class="wrapper-card bg-gray">
                            <div class="selected-options mb-0 px-3 py-2">
                                <div class="d-flex my-3">
                                    <div class="box-search">
                                        <div class="icon-search">
                                            <i class="material-icons">search</i>
                                        </div>
                                        <input
                                            type="text"
                                            :placeholder="`${$t('Search Product')}`"
                                            class="input-keyword"
                                            v-model="searchKeyword"
                                        >
                                    </div>
                                    <button
                                        class="btn btn-light btn-clear-all"
                                        @click="clearAll">
                                        <i class="material-icons md-sm">clear_all</i>
                                        {{ $t('Clear All') }}
                                    </button>
                                </div>
                                <div class="d-flex flex-wrap exclude" v-if="filteredProducts.length > 0">
                                    <div v-for="(item, i) in filteredProducts" :key="i" class="py-2 mr-2">
                                        <div class="d-flex align-items-center box-product">
                                            <div class="">{{ item.name }}</div>
                                            <i
                                                class="material-icons cur-p icon-close"
                                                @click="removeItemsProduct(item._id)"
                                                v-tooltip="$t('Remove')"
                                            >
                                                close
                                            </i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer">
            <button type="button" class="btn btn-light" @click="close">
                {{ $t("global.close") }}
            </button>
            <button type="button" class="btn btn-primary" @click="applyFilterProducts">
                {{ $t("global.applyFilter") }}
            </button>
        </div>
    </modal>
    </template>

<script>

import Modal from '@/components/Modal.vue';
import ProductMultiSelect from '@/components/ProductMultiSelect.vue';

export default {
	name: 'ModalFilterProduct',
	components: {
		Modal,
		ProductMultiSelect,
	},
	props: {
		mode: {
			type: String,
			default: '',
		},
		show: {
			type: Boolean,
			default: false,
		},
		products: {
			type: Array,
			default: () => [],
		},
		selectedProducts: {
			type: Array,
			default: () => [],
		},
	},

	data: () => ({
		newSelectedProducts: [],
		searchKeyword: '',
	}),

	computed: {
		filteredProducts() {
			const searchKeyword = this.searchKeyword.toLowerCase();
			let products = [];
			const filteredProducts = this.newSelectedProducts.filter(item => item.name.toLowerCase().includes(searchKeyword));
			if (filteredProducts.length > 0) {
				products = filteredProducts;
			}
			return products;
		},
	},

	methods: {
		close() {
			this.$emit('close');
		},
		removeItemsProduct(id) {
			const index = this.newSelectedProducts.findIndex(item => item._id === id);
			this.newSelectedProducts.splice(index, 1);
			this.$emit('remove-item', id);
		},
		onSelectProducts() {
			this.$emit('input', this.newSelectedProducts);
		},
		applyFilterProducts() {
			this.$emit('apply', this.mode ? this.mode : '');
		},
		clearAll() {
			this.newSelectedProducts = [];
			this.$emit('input', this.newSelectedProducts);
		},
	},
	watch: {
		selectedProducts: {
			immediate: true,
			handler(newVal) {
				this.newSelectedProducts = [...newVal];
			},
		},
	},
};
</script>

<style lang="scss">
.modal-filter-product {
    .box-product {
        position: relative;
        display: inline-block;
        padding: 8px 6px;
        border-radius: 5px;
        color: white;
        background-color: #41b883;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .btn-clear-all {
        border: 2px solid #ddd;
    }
    .icon-close {
        position: relative;
        font-size: 22px;
    }
    .w-250px {
        width: 250px;
    }
    .bg-gray {
        background-color: #F0F8FF;
    }
    .button-filter {
        position: relative;
        left: 15px;
    }

    .btn-filter-product {
        display:flex;
        justify-content: space-around;
    }

    .filter-list-icon {
        margin: 0 20px 0 0;
    }

    .wrapper-card {
        max-height: 400px;
        overflow-y: auto;
    }

    .box-search {
        align-items: center;
        background-color: #fff;
        border-color: #ddd;
        border-radius: 3px;
        border-width: 2px;
        border-style: solid;
        display: flex;
        max-width: 100%;
        width: 75%;
        margin-right: 10px;
        .input-keyword {
            outline: 0;
            border: 0px;
            font-size: 14px;
            padding: 8px 6px;
            width: 100%;
        }
        .icon-search {
            display: flex;
            margin-right: 6px;
            padding-left: 5px;
        }
    }
}
    </style>
